import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-course-district',
  templateUrl: './course-district.component.html',
  styleUrls: ['./course-district.component.scss']
})
export class CourseDistrictComponent implements OnInit {

  MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  session_link: any;
  mentor_data: any;



  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe) {
    this.createmeetingform= this.fb.group({
      course_name: ['',Validators.required],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['this.users.firstname',Validators.required],
      course_start_date: [this.getCurrentDates(), Validators.required],
      course_end_date: [this.getCurrentDates(), Validators.required],
      course_start_time: [this.getCurrentTime(), Validators.required],
      course_end_time: [this.getCurrentTime(), Validators.required],
  
      volunteer1:['',Validators.required],
      volunteer2: [''],
      user_id:[''],
      comments:['',Validators.required],
      course_location:['',Validators.required],
      status: [''],
      session_link: ['', [ this.linkValidator()]], // Using linkValidator here
      image:[''],
    
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit():void{
   
    this.date = new Date();

     this.ApiService.getMentorsList(this.users.district).subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
       this.mentor_data = data;
      
    })

    this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
      this.ob_data = data;
    })
    
// document.write(today);
    this.customers=[];
    this.showSpinner();
  
    this.ApiService.getDistrictOccurance().subscribe((data:any) => {
      
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers);
      
    });
    this.ApiService.getCourses().subscribe((data: any) => {
      console.log(data, "s,mfdnsd");
      this.courses = data;
    
     
     
     //console.log(this.customers.length);
     //console.log(obj.data.length);
     console.log(this.courses);
     })
   

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
    this.createmeetingform.get('organizer').setValue(this.users.firstname);

  }
  getCurrentDates(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()+1).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Function to get the current time in the format HH:MM
  getCurrentTime(): string {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  linkValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const linkPattern = /^(ftp|http|https):\/\/[^ "]+$/;

      if (control.value && !linkPattern.test(control.value)) {
        return { 'invalidLink': { value: control.value } };
      }

      return null;
    };
  }

  postdata(angForm1 : any) //angForm1
    {
    console.log(angForm1.value);

          this.ApiService.createDistrictOccurance(angForm1.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
              setTimeout(function () {
                      
                Swal.fire({
                  title: "Your Course District Occurrence created Successfully!",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: '#015792',
                  iconColor: '#015792', // Set the icon color here
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.reload();
                  } 
                });
                
                      
                      // window.location.reload();
                    }, 100)
                },
              
              error => {
                console.log(error);
              });
          }
    
 


delete_CM(id: any) {
  console.log(id);
  Swal.fire({
    title: 'Confirm Deletion',
    text: 'Are you sure you want to cancel this District Occurance?',
    icon: 'warning',
    showCancelButton: true,
    iconColor:'#015792',
    confirmButtonColor: '#015792',
    cancelButtonColor: '#e5183b',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      this.ApiService.deleteDistrictOccurance(id)
        .subscribe(
          data => {
            Swal.fire({
              title: 'Deletion Successful',
              text: 'Your Course District Occurrence has been deleted successfully!',
              icon: 'success',
              confirmButtonText: 'Okay',
              iconColor:'#015792',
              confirmButtonColor: '#015792',
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          },
          error => {
            console.log(error);
          }
        );
    }
  });
}



  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  CM_session_link: any;
  CM_course_image:any;


  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton);
    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
  this.CM_course_name=a.course_name;
  console.log('CM_course_name: ', this.CM_course_name);
  
    this.CM_district=a.district;
   // this.CM_constituency=a.constituency;
    this.CM_startDate = a.start_date;
    this.CM_organizer = a.organizer;
   this.CM_endDate=a.end_date;
    this.CM_startTime=a.start_time;
    this.CM_endTime=a.end_time;
    this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_id = a.id;
    this.CM_session_link = a.session_link;
    this.CM_course_image=a.image;

    this.editmeetingform.patchValue({
      course_name: a.course_name,
      district: a.district,
      organizer: this.users.firstname, // Assuming you want to set organizer as the logged-in user
      course_start_date: a.start_date,
      course_end_date: a.end_date,
      course_start_time: a.start_time,
      course_end_time: a.end_time,
      volunteer1: a.volunteer1,
      volunteer2: a.volunteer2,
      course_location: a.location,
      status: a.status,
      comments: a.comments,
      session_link: a.session_link,
      image: a.image,
      user_id:a.user_id,
      id:a.id,
      occurance_id: a.occurance_id,
    });
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }

          editformInitialize(a){
            this.editmeetingform= this.fb.group({
              occurance_id:[''],
           course_name: ['',Validators.required],
      district:[,Validators.required ],
   //   constituency:[this.current_time,Validators.required],
      organizer:['this.users.firstname',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: [''],
      user_id:[''],
      id:[''],
      comments:[''],
      course_location:['',Validators.required],
              status: [''],
              session_link: ['', [Validators.required, this.linkValidator()]], // Using linkValidator here
              image:['']
          });
          }
        
          updatedata(updateform,id){
            console.log(updateform,id);  
            this.spinner = true;
            console.log(this.CM_id,updateform.value)
            this.ApiService.updateDistrictOccurance(this.CM_id,updateform.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
                    setTimeout(function () {
                                   Swal.fire({
  title: "Your Course District Occurance updated Successfully!",
   icon: "success",
                  confirmButtonText: "Okay",
                  iconColor:'#015792',
                  confirmButtonColor: '#015792',
}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    window.location.reload();
  } 
});
                    }, 100)
                },
              
              error => {
                console.log(error);
              });
          }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}
getCurrentDate(): string {
  const today = new Date();
  today.setDate(today.getDate()+1);

  // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
  return today.toISOString().split('T')[0];
}
getFutureDate(): string {
  // Get the selected Course Start Date value
  const startDateValue = this.createmeetingform.get('course_start_date').value;
  
  // Parse the selected Course Start Date value
  const startDate = new Date(startDateValue);

  // Increment the selected Course Start Date by one day
  startDate.setDate(startDate.getDate());
  
  // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
  return startDate.toISOString().split('T')[0];
}


}
